import { TableItem } from 'components/atoms';
import { Table } from 'components/organisms';
import { useInfiniteTable } from 'hooks/useInfiniteTable';
import { useCustomParamId } from 'hooks/useParamId';
import { t } from 'i18next';
import { useGetArtistTracksInfinite } from 'services/artists/products';

const ArtistTracksTab = () => {
  const artistId = useCustomParamId('id');

  const tracks = useGetArtistTracksInfinite(artistId);

  const tableProps = useInfiniteTable(tracks);

  return (
    <Table
      id='artist-tracks'
      //   size='compact'
      {...tableProps}
      data={{
        nodes: tableProps.data.nodes.map(p => ({
          ...p,
          id: `/track/${p.id}/artists`,
        })),
      }}
      columns={[
        {
          label: t('input.label.title'),
          renderCell: ({ title }) => (
            <TableItem>
              <TableItem.Text text={title.title} />
            </TableItem>
          ),
        },
        {
          label: t('input.label.isrc'),
          renderCell: ({ isrc }) => (
            <TableItem>
              <TableItem.Text text={isrc} />
            </TableItem>
          ),
        },
      ]}
    />
  );
};

export default ArtistTracksTab;
